import React, { forwardRef } from 'react';
import { StyleSheet, Text, TextProps } from 'react-native';
import theme from 'shared/styles/theme';

const BodyXSText = forwardRef<Text, TextProps>(
  ({ children, style, ...props }, ref) => {
    return (
      <Text
        ref={ref}
        testID="body-xs"
        style={[styles.bodyXSText, style]}
        {...props}
      >
        {children}
      </Text>
    );
  },
);

const styles = StyleSheet.create({
  bodyXSText: {
    ...theme.typography.body.xs,
    color: theme.color.text.primary,
  },
});

export default BodyXSText;
